import styles from "./AffProgram.module.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Icon1 from "../../imgs/icon5.svg";
import Icon2 from "../../imgs/icon6.svg";
import Icon3 from "../../imgs/icon7.svg";
import Gradient from "../../imgs/gradient.svg";

export default function AffProgram() {
  const { t } = useTranslation();

  return (
    <div className={styles.affprogram_page}>
      <Header />
      <div className={styles.section1}>
      {/* <img className={styles.gradient} src={Gradient} alt="gradient" /> */}
        <div className={styles.section1Body}>
          <div className={styles.top}>
            <h1>
              {t(
                "Affiliate "
              )}
              <span>
              {t(
                "Program"
              )}
            </span>
            </h1>
            <h2>
              {t(
                "Become a "
              )}
              <span>
              {t(
                "Interactive Assets"
              )}
            </span>
            {t(
                " partner and earn high income on "
              )}
            <span>
              {t(
                "individual"
              )}
            </span>
            {t(
                " terms!"
              )}
            </h2>
            <p>
              {t(
                "The affiliate program from the cryptocurrency broker Interactive Assets is:"
              )}
            </p>
          </div>
          <div className={styles.bottom}>
            <div className={styles.blocks}>
              <div className={styles.top_blocks}>
                <div className={styles.block}>
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
  <path d="M33.666 25.9207C31.7098 32.1489 25.8912 36.6667 19.0174 36.6667C10.5391 36.6667 3.66602 29.7936 3.66602 21.3153C3.66602 14.4415 8.18377 8.62283 14.412 6.66666" stroke="url(#paint0_linear_3215_4431)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M36.8545 16.5788C35.0853 10.2406 30.0921 5.24743 23.7539 3.47818C21.0146 2.71351 18.666 5.09032 18.666 7.93438V19.0919C18.666 20.5139 19.8188 21.6667 21.2408 21.6667H32.3983C35.2424 21.6667 37.6192 19.3181 36.8545 16.5788Z" stroke="url(#paint1_linear_3215_4431)" stroke-width="1.5"/>
  <defs>
    <linearGradient id="paint0_linear_3215_4431" x1="3.66602" y1="21.6667" x2="33.666" y2="21.6667" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint1_linear_3215_4431" x1="18.666" y1="12.5" x2="36.9993" y2="12.5" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
  </defs>
</svg>
                  <p>
                    {t("Traffic monetization by multilingual segments: CIS")}
                  </p>
                </div>
                <div className={styles.block}>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <path d="M5 36.6667H35" stroke="url(#paint0_linear_3215_4434)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5 18.3333C5 16.762 5 15.9763 5.48816 15.4882C5.97631 15 6.76199 15 8.33333 15C9.90468 15 10.6904 15 11.1785 15.4882C11.6667 15.9763 11.6667 16.762 11.6667 18.3333V28.3333C11.6667 29.9047 11.6667 30.6904 11.1785 31.1785C10.6904 31.6667 9.90468 31.6667 8.33333 31.6667C6.76199 31.6667 5.97631 31.6667 5.48816 31.1785C5 30.6904 5 29.9047 5 28.3333V18.3333Z" stroke="url(#paint1_linear_3215_4434)" stroke-width="1.5"/>
  <path d="M16.666 11.6667C16.666 10.0953 16.666 9.30965 17.1542 8.8215C17.6423 8.33334 18.428 8.33334 19.9993 8.33334C21.5707 8.33334 22.3564 8.33334 22.8445 8.8215C23.3327 9.30965 23.3327 10.0953 23.3327 11.6667V28.3333C23.3327 29.9047 23.3327 30.6904 22.8445 31.1785C22.3564 31.6667 21.5707 31.6667 19.9993 31.6667C18.428 31.6667 17.6423 31.6667 17.1542 31.1785C16.666 30.6904 16.666 29.9047 16.666 28.3333V11.6667Z" stroke="url(#paint2_linear_3215_4434)" stroke-width="1.5"/>
  <path d="M28.334 6.66668C28.334 5.09533 28.334 4.30965 28.8221 3.8215C29.3103 3.33334 30.096 3.33334 31.6673 3.33334C33.2387 3.33334 34.0243 3.33334 34.5125 3.8215C35.0007 4.30965 35.0007 5.09533 35.0007 6.66668V28.3333C35.0007 29.9047 35.0007 30.6904 34.5125 31.1785C34.0243 31.6667 33.2387 31.6667 31.6673 31.6667C30.096 31.6667 29.3103 31.6667 28.8221 31.1785C28.334 30.6904 28.334 29.9047 28.334 28.3333V6.66668Z" stroke="url(#paint3_linear_3215_4434)" stroke-width="1.5"/>
  <defs>
    <linearGradient id="paint0_linear_3215_4434" x1="5" y1="37.1667" x2="35" y2="37.1667" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint1_linear_3215_4434" x1="5" y1="23.3333" x2="11.6667" y2="23.3333" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint2_linear_3215_4434" x1="16.666" y1="20" x2="23.3327" y2="20" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint3_linear_3215_4434" x1="28.334" y1="17.5" x2="35.0007" y2="17.5" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
  </defs>
</svg>
                  <p>{t("Absolutely transparent accrual statistics")}</p>
                </div>
                <div className={styles.block}>
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
  <path d="M16.9697 6.48457C17.9095 5.68369 18.3794 5.28325 18.8707 5.04842C20.007 4.5053 21.328 4.5053 22.4643 5.04842C22.9556 5.28325 23.4255 5.68369 24.3653 6.48457C24.7393 6.80332 24.9264 6.9627 25.1261 7.09657C25.584 7.40345 26.0981 7.61643 26.6389 7.72319C26.8748 7.76976 27.1197 7.78931 27.6096 7.8284C28.8404 7.92662 29.4559 7.97573 29.9693 8.15709C31.1569 8.57654 32.0909 9.51064 32.5104 10.6982C32.6918 11.2116 32.7409 11.827 32.8391 13.0579C32.8782 13.5478 32.8977 13.7927 32.9443 14.0286C33.0511 14.5693 33.264 15.0835 33.5709 15.5414C33.7048 15.7411 33.8642 15.9281 34.1829 16.3022C34.9838 17.242 35.3842 17.7119 35.6191 18.2032C36.1622 19.3395 36.1622 20.6605 35.6191 21.7968C35.3842 22.2881 34.9838 22.758 34.1829 23.6978C33.8642 24.0718 33.7048 24.2589 33.5709 24.4586C33.264 24.9164 33.0511 25.4306 32.9443 25.9714C32.8977 26.2073 32.8782 26.4522 32.8391 26.9421C32.7409 28.1729 32.6918 28.7884 32.5104 29.3018C32.0909 30.4893 31.1569 31.4234 29.9693 31.8429C29.4559 32.0242 28.8404 32.0734 27.6096 32.1716C27.1197 32.2107 26.8748 32.2302 26.6389 32.2768C26.0981 32.3835 25.584 32.5965 25.1261 32.9034C24.9264 33.0373 24.7393 33.1967 24.3653 33.5154C23.4255 34.3163 22.9556 34.7167 22.4643 34.9516C21.328 35.4947 20.007 35.4947 18.8707 34.9516C18.3794 34.7167 17.9095 34.3163 16.9697 33.5154C16.5957 33.1967 16.4086 33.0373 16.2089 32.9034C15.751 32.5965 15.2369 32.3835 14.6961 32.2768C14.4602 32.2302 14.2153 32.2107 13.7254 32.1716C12.4946 32.0734 11.8791 32.0242 11.3657 31.8429C10.1781 31.4234 9.24405 30.4893 8.8246 29.3018C8.64324 28.7884 8.59413 28.1729 8.49591 26.9421C8.45682 26.4522 8.43727 26.2073 8.3907 25.9714C8.28394 25.4306 8.07096 24.9164 7.76408 24.4586C7.63021 24.2589 7.47083 24.0718 7.15208 23.6978C6.3512 22.758 5.95076 22.2881 5.71594 21.7968C5.17281 20.6605 5.17281 19.3395 5.71594 18.2032C5.95076 17.7119 6.3512 17.242 7.15208 16.3022C7.47083 15.9281 7.63021 15.7411 7.76408 15.5414C8.07096 15.0835 8.28394 14.5693 8.3907 14.0286C8.43727 13.7927 8.45682 13.5478 8.49591 13.0579C8.59413 11.827 8.64324 11.2116 8.8246 10.6982C9.24405 9.51064 10.1781 8.57654 11.3657 8.15709C11.8791 7.97573 12.4946 7.92662 13.7254 7.8284C14.2153 7.78931 14.4602 7.76976 14.6961 7.72319C15.2369 7.61643 15.751 7.40345 16.2089 7.09657C16.4086 6.9627 16.5957 6.80332 16.9697 6.48457Z" stroke="url(#paint0_linear_3215_4437)" stroke-width="1.5"/>
  <path d="M15.668 25L25.668 15" stroke="url(#paint1_linear_3215_4437)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M26.0013 24.1667C26.0013 24.811 25.479 25.3333 24.8346 25.3333C24.1903 25.3333 23.668 24.811 23.668 24.1667C23.668 23.5223 24.1903 23 24.8346 23C25.479 23 26.0013 23.5223 26.0013 24.1667Z" fill="url(#paint2_linear_3215_4437)" stroke="url(#paint3_linear_3215_4437)"/>
  <path d="M17.6673 15.8333C17.6673 16.4777 17.145 17 16.5007 17C15.8563 17 15.334 16.4777 15.334 15.8333C15.334 15.189 15.8563 14.6667 16.5007 14.6667C17.145 14.6667 17.6673 15.189 17.6673 15.8333Z" fill="url(#paint4_linear_3215_4437)" stroke="url(#paint5_linear_3215_4437)"/>
  <defs>
    <linearGradient id="paint0_linear_3215_4437" x1="5.30859" y1="20" x2="36.0264" y2="20" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint1_linear_3215_4437" x1="15.668" y1="20" x2="25.668" y2="20" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint2_linear_3215_4437" x1="23.168" y1="24.1667" x2="26.5013" y2="24.1667" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint3_linear_3215_4437" x1="23.168" y1="24.1667" x2="26.5013" y2="24.1667" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint4_linear_3215_4437" x1="14.834" y1="15.8333" x2="18.1673" y2="15.8333" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint5_linear_3215_4437" x1="14.834" y1="15.8333" x2="18.1673" y2="15.8333" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
  </defs>
</svg>
                  <p>
                    {t("Well-established algorithm and high conversion rate")}
                  </p>
                </div>
              </div>
              <div className={styles.bottom_blocks}>
                <div className={styles.block}>
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
  <path d="M36.9978 18.3334C36.9826 13.1428 36.8185 10.3911 35.0467 8.61931C33.0941 6.66669 29.9514 6.66669 23.666 6.66669H16.9993C10.714 6.66669 7.57126 6.66669 5.61864 8.61931C3.66602 10.5719 3.66602 13.7146 3.66602 20C3.66602 26.2854 3.66602 29.4281 5.61864 31.3807C7.57126 33.3334 10.714 33.3334 16.9993 33.3334H19.4993" stroke="url(#paint0_linear_3215_4441)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M26.1663 23.3333V33.3333M26.1663 33.3333L29.4997 30M26.1663 33.3333L22.833 30M33.6663 33.3333V23.3333M33.6663 23.3333L36.9997 26.6666M33.6663 23.3333L30.333 26.6666" stroke="url(#paint1_linear_3215_4441)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M16.9997 26.6667H10.333" stroke="url(#paint2_linear_3215_4441)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M3.66602 16.6667L36.9994 16.6667" stroke="url(#paint3_linear_3215_4441)" stroke-width="1.5" stroke-linecap="round"/>
  <defs>
    <linearGradient id="paint0_linear_3215_4441" x1="3.66602" y1="20" x2="36.9978" y2="20" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint1_linear_3215_4441" x1="22.833" y1="28.3333" x2="36.9997" y2="28.3333" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint2_linear_3215_4441" x1="10.333" y1="27.1667" x2="16.9997" y2="27.1667" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint3_linear_3215_4441" x1="3.66602" y1="17.1667" x2="36.9994" y2="17.1667" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
  </defs>
</svg>
                  <p>
                    {t(
                      "Flexible individual terms and commission-free payments"
                    )}
                  </p>
                </div>
                <div className={styles.block}>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <circle cx="20.0007" cy="9.99998" r="6.66667" stroke="url(#paint0_linear_3215_4444)" stroke-width="1.5"/>
  <path d="M30 15C32.7614 15 35 13.1345 35 10.8334C35 8.53217 32.7614 6.66669 30 6.66669" stroke="url(#paint1_linear_3215_4444)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M10 15C7.23858 15 5 13.1345 5 10.8334C5 8.53217 7.23858 6.66669 10 6.66669" stroke="url(#paint2_linear_3215_4444)" stroke-width="1.5" stroke-linecap="round"/>
  <ellipse cx="20" cy="28.3334" rx="10" ry="6.66667" stroke="url(#paint3_linear_3215_4444)" stroke-width="1.5"/>
  <path d="M33.334 31.6666C36.2577 31.0255 38.334 29.4018 38.334 27.5C38.334 25.5982 36.2577 23.9745 33.334 23.3333" stroke="url(#paint4_linear_3215_4444)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M6.66602 31.6666C3.74227 31.0255 1.66602 29.4018 1.66602 27.5C1.66602 25.5982 3.74227 23.9745 6.66602 23.3333" stroke="url(#paint5_linear_3215_4444)" stroke-width="1.5" stroke-linecap="round"/>
  <defs>
    <linearGradient id="paint0_linear_3215_4444" x1="13.334" y1="9.99998" x2="26.6673" y2="9.99998" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint1_linear_3215_4444" x1="30" y1="10.8334" x2="35" y2="10.8334" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint2_linear_3215_4444" x1="10" y1="10.8334" x2="5" y2="10.8334" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint3_linear_3215_4444" x1="10" y1="28.3334" x2="30" y2="28.3334" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint4_linear_3215_4444" x1="33.334" y1="27.5" x2="38.334" y2="27.5" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint5_linear_3215_4444" x1="6.66602" y1="27.5" x2="1.66602" y2="27.5" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
  </defs>
</svg>
                  <p>{t("Personal work with each program participant")}</p>
                </div>
                <div className={styles.block}>
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
  <path d="M37.3353 17.5V20C37.3353 27.8567 37.3353 31.7851 34.8945 34.2259C32.4537 36.6666 28.5254 36.6666 20.6686 36.6666C12.8119 36.6666 8.88351 36.6666 6.44273 34.2259C4.00195 31.7851 4.00195 27.8567 4.00195 20C4.00195 12.1432 4.00195 8.21487 6.44273 5.77409C8.88351 3.33331 12.8119 3.33331 20.6686 3.33331H23.1686" stroke="url(#paint0_linear_3215_4447)" stroke-width="1.5" stroke-linecap="round"/>
  <ellipse cx="32.334" cy="8.33331" rx="5" ry="5" stroke="url(#paint1_linear_3215_4447)" stroke-width="1.5"/>
  <path d="M12.334 23.3334L16.1555 19.5119C16.8063 18.861 17.8616 18.861 18.5125 19.5119L21.1555 22.1548C21.8063 22.8057 22.8616 22.8057 23.5125 22.1548L29.0007 16.6667M29.0007 16.6667V20.8334M29.0007 16.6667H24.834" stroke="url(#paint2_linear_3215_4447)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <defs>
    <linearGradient id="paint0_linear_3215_4447" x1="4.00195" y1="20" x2="37.3353" y2="20" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint1_linear_3215_4447" x1="27.334" y1="8.33331" x2="37.334" y2="8.33331" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
    <linearGradient id="paint2_linear_3215_4447" x1="12.334" y1="20" x2="29.0007" y2="20" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C298"/>
      <stop offset="0.435" stop-color="#62C687"/>
      <stop offset="0.678511" stop-color="#A0CA7D"/>
      <stop offset="1" stop-color="#E6CC70"/>
    </linearGradient>
  </defs>
</svg>
                  <p>{t("A wide range of proven marketing materials")}</p>
                </div>
              </div>
            </div>
            <Link to='/cabinet'>{t("Become a partner")}</Link>
          </div>
        </div>
      </div>
      <div className={styles.section2}>
        <div className={styles.section2Body}>
          <div className={styles.title}>
            <h1>
            <span>
              {t(
                "Interactive Assets"
              )}
            </span>
              {t(
                " offers its "
              )}
              <span>
              {t(
                "partners"
              )}
            </span>
            {t(
                " three cooperation options to choose from:"
              )}
            </h1>
          </div>
          <div className={styles.blocks}>
            <div className={styles.block}>
              <span className={styles.number}>
                <img src={Icon1} alt="icon" />
              </span>
              <div className={styles.text}>
                <h5>{t("REVENUE SHARE - FROM 30% TO 45%")}</h5>
                <p>
                  {t(
                    "Throughout the time of work of the client you have brought in, you receive a percentage of his income."
                  )}
                  <br />
                  <br />
                  {t(
                    "The size of the interest rate depends directly on the number and activity of your clients."
                  )}
                </p>
              </div>
            </div>
            <div className={styles.block}>
              <span className={styles.number}>
                <img src={Icon2} alt="icon" />
              </span>
              <div className={styles.text}>
                <h5>CPA</h5>
                <p>
                  {t(
                    "You will receive a one-time fixed payment for each client who opens a deposit with Interactive Assets."
                  )}
                </p>
                <br />
                <p>
                  {t(
                    "The size of the CPA can increase along with the number of invited clients. The terms of cooperation are discussed individually with each partner."
                  )}
                </p>
              </div>
            </div>
            <div className={styles.block}>
              <span className={styles.number}>
                <img src={Icon3} alt="icon" />
              </span>
              <div className={styles.text}>
                <h5>{t("CPA + REVENUE SHARE")}</h5>
                <p>
                  {t(
                    "A convenient form of cooperation that combines a deposit rate and a regular percentage of the client's income."
                  )}
                </p>
                <br />
                <p>
                  {t(
                    "To get personal terms of work, please contact the affiliate program manager."
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.section3}>
        <div className={styles.section3Body}>
          <div className={styles.top}>
            <h1>{t("Join the Interactive Assets affiliate program today!")}</h1>
            <p>
              {t(
                "Earn profit on favorable terms. Simply fill out the registration form, after which the affiliate program manager will contact you to complete the registration of your account."
              )}
            </p>
          </div>
          <div className={styles.form}>
            <div className={styles.inputs}>
              <div className={styles.input_label}>
                <label htmlFor="">{t("Name")}</label>
                <input type="text" placeholder={t("Name")} />
              </div>
              <div className={styles.input_label}>
                <label htmlFor="">{t("Surname")}</label>
                <input type="text" placeholder={t("Surname")} />
              </div>
              <div className={styles.input_label}>
                <label htmlFor="">{t("Phone")}</label>
                <input type="text" placeholder={t("Phone")} />
              </div>
              <div className={styles.input_label}>
                <label htmlFor="">{t("Email")}</label>
                <input type="text" placeholder={t("Email")} />
              </div>
            </div>
            <div className={styles.textarea_block}>
              <label htmlFor="">{t("Message")}</label>
              <textarea
                name="Message"
                id=""
                placeholder={t("Message")}
              ></textarea>
            </div>
            <div className={styles.link_block}>
              <Link to="/cabinet">{t("Become a partner")}</Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
